import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import SVGImage from '~/components/Image/SVGImage'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { AppLanguage } from '~/types/locale'
import { ArticleProductAPIStat } from '~/redux/apis/user-stats-api'
import { getColorClassnameFromId } from '~/statistics/utils/common.utils'
import useArticleProductCardStats from '~/statistics/hooks/useEncyclopediaCardsStats'

import TimeStat from '../../ProfileCards/TimeStat'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  product: ArticleProductAPIStat
}

export default function Summary({ showContent, onClick, product }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const {
    subjectTitle,
    title,
    timeSpent: { days, hours, minutes },
    correctAnswerPercentage,
    activitiesSummary: { totalSetsCount },
  } = useArticleProductCardStats(product)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title })
  }

  const titleColorClassname = getColorClassnameFromId(product.id)

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={title}
        hrefLocale={AppLanguage.NO}
        iconAltText={t('alt_texts.vcc')}
        iconSrcKey="scoreboard/math-article.png"
        onClickTitle={onClickTitle}
        productSubtitle={subjectTitle}
        productTitle={t('mathArticle')}
        showContent={showContent}
        titleClassname={`text-${titleColorClassname}`}
      />
      <div className="font-medium flex justify-between">
        <div className="flex items-center">
          <SVGImage alt={t('alt_texts.clock')} className="mr-2" height={20} srcKey="scoreboard/clock.svg" width={20} />
          <TimeStat days={days} hours={hours} minutes={minutes} />
        </div>
        {totalSetsCount && (
          <p>
            {t('correct-answer')} {correctAnswerPercentage}%
          </p>
        )}
      </div>
    </button>
  )
}
